/**
 * Shared constants for CIH page components.
 *
 * Aliases: cih constants, light hero gradient, framework type meta
 */

import { FrameworkType } from "~/lib/schemas/db-enums-cih";

/** Light hero gradient used on Framework, CCO, and CTP detail pages. */
export const CIH_LIGHT_HERO_GRADIENT =
  "bg-gradient-to-b from-purple-50/50 via-white to-white";

/** Framework type visual metadata — colors, icons, labels per type. */
export const FRAMEWORK_TYPE_META: Record<
  FrameworkType,
  {
    label: string;
    pluralLabel: string;
    icon: string;
    accent: string;
    bg: string;
    text: string;
  }
> = {
  [FrameworkType.Framework]: {
    label: "Framework",
    pluralLabel: "Frameworks",
    icon: "layers",
    accent: "linear-gradient(135deg, #3b82f6, #93c5fd)",
    bg: "bg-blue-50 group-hover:bg-blue-100",
    text: "text-blue-700",
  },
  [FrameworkType.Methodology]: {
    label: "Methodology",
    pluralLabel: "Methodologies",
    icon: "compass",
    accent: "linear-gradient(135deg, #8b5cf6, #c4b5fd)",
    bg: "bg-purple-50 group-hover:bg-purple-100",
    text: "text-purple-700",
  },
  [FrameworkType.Standard]: {
    label: "Standard",
    pluralLabel: "Standards",
    icon: "shield-check",
    accent: "linear-gradient(135deg, #14b8a6, #5eead4)",
    bg: "bg-teal-50 group-hover:bg-teal-100",
    text: "text-teal-700",
  },
  [FrameworkType.Protocol]: {
    label: "Protocol",
    pluralLabel: "Protocols",
    icon: "clipboard-list",
    accent: "linear-gradient(135deg, #f97316, #fdba74)",
    bg: "bg-orange-50 group-hover:bg-orange-100",
    text: "text-orange-700",
  },
};
